export default {
  have_account: 'Já tem conta?',
  sign_in: 'Entrar',
  sign_in_description: 'para usar os seus pontos e informações guardadas',
  join_free: 'Aderir gratuitamente',
  join_description: '— ganhe recompensas em cada encomenda',
  join_description_with_discount: `— ganhe recompensas como até <highlight>{{max_discount}} de desconto</highlight> por encomenda`,
  join_description_with_product_and_discount: `— ganhe recompensas como {{product_name}} grátis e até <highlight>{{max_discount}} de desconto</highlight> por encomenda`,
  demo_mode: 'Modo de demonstração',
};
